import { useFlashStore } from './useFlashStore';

export type ToastKind = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  message: string;
}

/** Canonical notification API; the store remains the single UI-state owner. */
export function useToasts() {
  const { messages, show, dismiss } = useFlashStore();
  return {
    toasts: messages as ToastMessage[],
    push: show,
    dismiss,
  };
}
